import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import ExpandedSVG from 'images/card/Shrink.svg';
import ShrinkedSVG from 'images/card/Expand.svg';

const buttonStyle = {
  minWidth: '52px',
  width: '24px',
  height: '37px',
  lineHeight: 'initial',
};

export default class CardExpandShrinkButton extends React.PureComponent {
  render() {
    const image = this.props.expanded ? ExpandedSVG : ShrinkedSVG;
    return (
      <FlatButton
        style={buttonStyle}
        hoverColor="initial"
        icon={<img alt="card expand shrink" src={image} className="button-img" />}
        onClick={this.props.onExpandedChange}
        className={this.props.className}
      />
    );
  }
}
